export const CLIENTS_SET_DATA_LOADING_STATE = 'CLIENTS_SET_DATA_LOADING_STATE';
export const CLIENTS_SET_REQUEST_LOADING_STATE = 'CLIENTS_SET_REQUEST_LOADING_STATE';
export const CLIENTS_SET_LOADING_STATE = 'CLIENTS_SET_LOADING_STATE';
export const CLIENTS_SET_ERROR = 'CLIENTS_SET_ERROR';
export const CLIENTS_RESET_ERROR = 'CLIENTS_RESET_ERROR';
export const CLIENTS_SET_CLIENT_DATA = 'CLIENTS_SET_CLIENT_DATA';
